/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import Cookies from 'universal-cookie';
import { useAccount } from 'wagmi';
import FunAbi from '../config/PumpFunAbi.json';
import TokenAbi from '../config/TokenAbi.json';
import { readContract, writeContract, waitForTransactionReceipt } from 'wagmi/actions'
import Web3 from 'web3';
import { toast } from 'react-hot-toast';
import ClaimCard from '../components/ClaimCard.jsx';
import bnb from '../icons/bnb.svg';
import eth from '../icons/ETH.svg';
import pol from '../icons/polygon.svg';
import pancakeBannerImg from '../icons/pancake-banner.png';
import swapIconDark from '../icons/swapIconDark.png';
import swapIconLight from '../icons/swapIconLight.png';
import TopBar from '../components/TopBar';
import ClipLoader from 'react-spinners/ClipLoader';
import { useQueryParam, StringParam } from 'use-query-params';
import MyChart from '../components/Chart.jsx';
import Chart from '../components/tradingview/index.js';
import CopyIcon from '../icons/copy.svg';
import rot13 from '../utils/encode.ts';
import { web3Clients, imageUrl, apiUrl, fetchBnbPrice, scanApiLinks, apiKeys, scanLinks, chainNames, coinNames, projectName } from '../utils/constants.ts';
import { getDefaultAddress } from '../utils/addressHelpers.ts';
import { config } from '../config.jsx';
import { BASE_URL } from '../utils/constants.ts';
import CustomRadioButton from '../components/CustomRadioButton';
import { SignMessage } from './SignMessage.jsx';
import Jazzicon, { jsNumberForAddress } from 'react-jazzicon';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import Footer from '../components/Footer';

const App = () => {
  const ethIcon = {
    1: eth,
    56: bnb,
    11155111: eth,
    8453: eth,
    137: pol,
    97: bnb,
  };
  let [addressDatas] = useQueryParam('address', StringParam);
  let FunAddress;
  let ref;
  if (addressDatas.includes('/?ref=')) {
    FunAddress = addressDatas.split('/?ref=')[0];
    ref = addressDatas.split('/?ref=')[1];
  } else {
    FunAddress = addressDatas;
  }
  let [chainId] = useQueryParam('chain', StringParam);
  const { address } = useAccount();
  const [tokenName, setTokenName] = useState('');
  const [tokenSymbol, setTokenSymbol] = useState('');
  const [maxLimit, setMaxLimit] = useState(1);
  const [tokenAddress, setTokenAddress] = useState('');
  const tokenLogo = imageUrl + 'logo/' + projectName + "-" + chainId + "-" + FunAddress + '.png';
  const tokenBanner = imageUrl + 'banner/' + projectName + "-" + chainId + "-" + FunAddress + '.png';
  const [virtualLp, setVirtualLiquidiity] = useState(0);
  const [maxBuyAmount, setMaxBuyAmount] = useState(0);
  const [tokenAmount, setAmount] = useState();
  const [tokenOutAmount, setTokenOutAmount] = useState(0);
  let [accountBalance, setAccountBalance] = useState(0);
  let [, setInputBalance] = useState(0);
  let [tokenBalance, setTokenBalance] = useState(0);
  let [tokenAllowance, setTokenAllowance] = useState(0);
  const [virtualTokenLp, setVirtualTokenLp] = useState();
  const [tokenPrice, setTokenPrice] = useState(0);
  let [creating, setCreating] = useState(false);
  const [website, setWebsite] = useState();
  const [twitter, setTwitter] = useState();
  const [telegram, setTelegram] = useState();
  const [telegramChatId, setTelegramChatId] = useState();
  const [inputToken, setInputToken] = useState('ETH');
  const [transactions, setTransactions] = useState([]);
  const [transactionDatas, setTransactionDatas] = useState([]);
  const [tokenPriceDatas, setTokenPriceDatas] = useState();
  const [volume, setVolume] = useState(0);
  const [contractAddress, setContractAddress] = useState('');
  const [description, setDescription] = useState('');
  const { theme } = useTheme();
  const [refCounts, setRefCounts] = useState(0);
  const [totalRefAmounts, setTotalRefAmounts] = useState(0);
  const [refUserAmount, setRefUserAmout] = useState(0);
  const [lpCreated, setLpCreated] = useState(false);
  const [ethPrice, setEthPrice] = useState();
  const [chatHistory, setChatHistory] = useState([]);
  const [chatContent,] = useState('');

  let max =
    '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff';

  const cookies = new Cookies();
  if (ref) {
    if (Web3.utils.isAddress(rot13(ref))) {
      cookies.set('ref', ref);
    }
  }
  let refAddress;
  if (cookies.get('ref')) {
    if (Web3.utils.isAddress(rot13(cookies.get('ref')))) {
      refAddress = rot13(cookies.get('ref'));
    }
  } else {
    refAddress = getDefaultAddress();
  }
  const REF_URL = BASE_URL + '/buy/?chain=' + chainId + '&address=' + FunAddress
  const referlink = address ? `${REF_URL}/?ref=${rot13(address)}` : `${REF_URL}/?ref=`

  const copyAddress = address => async e => {
    e.stopPropagation();
    e.preventDefault();
    if (document.queryCommandSupported('copy')) {
      const ele = document.createElement('textarea');
      ele.value = address;
      document.body.appendChild(ele);
      ele.select();
      document.execCommand('copy');
      document.body.removeChild(ele);
      toast.success('Copied to clipboard');
    }
  };

  const onTokenSwap = async () => {
    try {
      setCreating(true);
      let swap;
      let sendData;
      if (inputToken === 'ETH') {
        if (tokenOutAmount + Number(tokenBalance) > 1000000000 * maxBuyAmount / 100) {
          toast.error("You can't purchase more than max buy limit");
          setCreating(false);
          return;
        }
        swap = await writeContract(config, {
          address: FunAddress,
          abi: FunAbi,
          functionName: 'buyToken',
          value: web3Clients[chainId].utils.toWei(String(tokenAmount), 'ether'),
          args: [refAddress],
          chainId: 56
        });
        await waitForTransactionReceipt(config, {
          hash: swap,
        });
        let tglink;
        if (telegram) {
          tglink = telegram;
          if (tglink?.includes("https")) {
            tglink = tglink.replace("https://t.me/", '')
            tglink = "@".concat(tglink)
          } else {
            if (!tglink?.includes("@")) {
              tglink = "@".concat(tglink)
            }
          }
        }
        let tgId;
        if (telegramChatId) {
          tgId = telegramChatId;
          if (tgId?.includes("https")) {
            tgId = tgId.replace("https://t.me/", '')
            tgId = "@".concat(tgId)
          } else {
            if (!tgId?.includes("@")) {
              tgId = "@".concat(tgId)
            }
          }
        }

        const FunInfo = await readContract(config, {
          address: FunAddress,
          abi: FunAbi,
          functionName: 'getFunBasicInfo',

        });

        sendData = {
          chainId,
          buyer: address,
          type: 'bought',
          name: tokenSymbol,
          amount: tokenAmount,  // eth amount
          token: tokenAddress,
          contract: contractAddress,
          timestamp: (Date.now() / 1000).toFixed(0),
          tokenPrice: Number(FunInfo[0][8]),
          ethPrice: ethPrice,
          tokenName: tokenName,
          tokenBalance: tokenOutAmount,  // token amount
          currentMarketCap: 2 * virtualLp * ethPrice / virtualTokenLp / 2 * 10 ** 9,
          txHash: swap,
          tgLink: tglink,
          tgId: tgId
        }

      } else {
        if (tokenAllowance > tokenAmount) {
          if (tokenAmount > 1000000000 * maxBuyAmount / 100) {
            toast.error("You can't sell more than max sell limit");
            setCreating(false);
            return;
          }

          swap = await writeContract(config, {
            address: FunAddress,
            abi: FunAbi,
            functionName: 'sellToken',
            args: [web3Clients[chainId].utils.toWei(String(tokenAmount), 'ether'), refAddress],

          });

          await waitForTransactionReceipt(config, {
            hash: swap,
          });
          sendData = {
            chainId,
            buyer: address,
            type: 'Sold',
            name: tokenSymbol,
            amount: tokenAmount,
            token: tokenAddress,
            contract: contractAddress,
            timestamp: (Date.now() / 1000).toFixed(0)
          };
        } else {
          let approve;
          let approveAddress;
          approveAddress = FunAddress;
          approve = await writeContract(config, {
            address: tokenAddress,
            abi: TokenAbi,
            functionName: 'approve',
            args: [approveAddress, max],

          });
          await waitForTransactionReceipt(config, {
            hash: approve,
          });
          toast.success("Successfully approved tokens");
          setCreating(false);
          return;
        }
        setInputToken(inputToken);
      }
      if (sendData) {
        const response = await fetch(apiUrl + '/addHistory', {
          method: 'POST',
          mode: 'cors',
          cache: 'no-cache',
          headers: {
            'Content-Type': 'application/json'
          },
          redirect: 'error',
          body: JSON.stringify(sendData)
        });
        if (response.status !== 200) {
          const { error } = await response.json();
          throw new Error(error);
        }
      }
      setTimeout(function () {
        setCreating(false);
      }, 3000);
      toast.success(`Successfully  ${inputToken !== 'ETH' ? Number(tokenAmount).toLocaleString() + " " + tokenSymbol : Number(tokenAmount) + " " + coinNames[chainId]} swapped`);
    } catch (err) {
      console.log(err)
      if (tokenOutAmount + Number(tokenBalance) > 1000000000 * maxBuyAmount / 100) {
        const remainTokenAmount = 1000000000 * maxBuyAmount / 100 - Number(tokenBalance);
        toast.error("You can't purchase more than " + remainTokenAmount.toLocaleString() + ' ' + tokenSymbol);
      } else {
        const errText = err.toString()
        if (errText.includes("connector")) {
          toast.error('There is a problem with your wallet connection. Please refresh and try again');
          setTimeout(function () {
            window.location.reload();
          }, 2000);
          setCreating(false);
          return;
        }
        toast.error('There is a problem with your Swap. Please try again later');
      }
      setCreating(false);
    }
  };

  useEffect(() => {
    const FetchData = async () => {
      try {
        const FunInfo = await readContract(config, {
          address: FunAddress,
          abi: FunAbi,
          functionName: 'getFunBasicInfo',

        });

        const AllPriceInfo = await readContract(config, {
          address: FunAddress,
          abi: FunAbi,
          functionName: 'getAllPrices',

        })

        const bnbPrice = await fetchBnbPrice()
        setEthPrice(bnbPrice)
        setVolume((Number(FunInfo[0][9]) * bnbPrice))
        setTokenPriceDatas(AllPriceInfo)
        setTokenName(FunInfo[1][0])
        setTokenSymbol(FunInfo[1][1])
        setTokenAddress(FunInfo[2][1])
        setMaxLimit(Number(FunInfo[0][2]))
        setVirtualLiquidiity(Number(FunInfo[0][5]) / 10 ** 18)
        setVirtualTokenLp(Number(FunInfo[0][4]) / 10 ** 18)
        setTokenPrice(Number(FunInfo[0][8]))
        setMaxBuyAmount(Number(FunInfo[0][2]))
        setWebsite(FunInfo[1][2])
        setTwitter(FunInfo[1][3])
        setTelegram(FunInfo[1][4])
        setTelegramChatId(FunInfo[1][7])
        setContractAddress(FunInfo[2][0])
        setRefCounts(Number(FunInfo[0][7]))
        setTotalRefAmounts(Number(FunInfo[0][6]) / 10 ** 18)
        setDescription(FunInfo[1][6])
        setLpCreated(FunInfo[4])
        if (address) {
          let accountBalance = await web3Clients[chainId].eth.getBalance(address);
          accountBalance = web3Clients[chainId].utils.fromWei(accountBalance, 'ether');
          setAccountBalance(accountBalance);
          if (inputToken === 'ETH') {
            setInputBalance(accountBalance);
          } else {
            setInputBalance(tokenBalance);
          }
          const refUserAmounts = await readContract(config, {
            address: FunAddress,
            abi: FunAbi,
            functionName: 'refAmounts',
            args: [address],

          });
          setRefUserAmout(Number(refUserAmounts) / (10 ** 18));

        }
      } catch (e) {
        console.error(e);
      }
    };
    if (creating === false) {
      FetchData();
    }
  }, [chainId, creating, FunAddress, address, inputToken, tokenBalance])

  const getApi = async () => {
    const AllPriceInfo = await readContract(config, {
      address: FunAddress,
      abi: FunAbi,
      functionName: 'getAllPrices',
    })
    setTokenPriceDatas(AllPriceInfo)

    try {
      const bnbPrice = await fetchBnbPrice()
      setEthPrice(bnbPrice)
    } catch (e) {
      console.error(e);
    }

    try {
      await fetch(
        apiUrl + `/getOne/${FunAddress}`,
        {
          method: 'GET'
        }
      ).then(async res => {
        let data = await res.json();
        if (!data.message) {
          let history;
          let historyData = [];
          for (let i = 0; i < data?.length; i++) {
            let sender = data[i].sender;
            let content = data[i].content;
            let currentDate = Date.now();
            let date = currentDate / 1000 - Number(data[i].timestamp);
            if (date > 86400) {
              date = (date / 86400).toFixed(0) + ' days ago';
            } else if (date > 3600) {
              date = (date / 3600).toFixed(0) + ' hours ago';
            } else if (date > 0) {
              date = (date / 60).toFixed(0) + ' mins ago';
            } else {
              date = ' just now';
            }
            let userAvatarUrl = imageUrl + `profile-${sender}.png`;
            history = { Sender: sender, Content: content, Date: date, avatar: userAvatarUrl };
            historyData.push(history);
          }
          setChatHistory(historyData);
        }
      });
    } catch (e) {
      console.error(e);
    }

    // get transaction
    try {
      if (FunAddress) {
        await fetch(
          `${scanApiLinks[chainId]}?chainid=${chainId}&module=account&action=txlist&address=${FunAddress}&startblock=0&endblock=99999999&apiKey=${apiKeys[chainId]}`,
          {
            method: 'GET'
          }
        ).then(async res => {
          let data = await res.json();
          if (data.status === "1") {
            setTransactions(data.result.filter(item => item.isError === "0"));
          }
        });
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => getApi(), 100000);
    return () => clearInterval(interval);
  });

  const setMaxAmount = async () => {
    if (accountBalance > 0) accountBalance = accountBalance - 0.00001;
    if (inputToken === 'ETH') {
      setAmount(accountBalance);
    } else {
      setAmount(tokenBalance);
    }
  };

  useEffect(() => {
    const FetchAmount = async () => {
      try {
        let id;
        if (inputToken === 'ETH') {
          id = '1';
        } else {
          id = '0';
        }
        let amounts;
        if (Number(tokenAmount) > 0) {
          amounts = await readContract(config, {
            address: FunAddress,
            abi: FunAbi,
            functionName: 'ethOrTokenAmount',
            args: [web3Clients[chainId].utils.toWei(String(tokenAmount), 'ether'), id],

          });

          setTokenOutAmount(Number((Number(amounts) / 10 ** 18).toFixed(6)));
        } else {
          setTokenOutAmount('');
        }
      } catch (e) {
        console.error(e);
      }
    };
    if (creating === false) {
      FetchAmount();
    }
  }, [inputToken, tokenAmount, creating, FunAddress, chainId]);

  const chanageCurrency = async () => {
    if (inputToken === 'ETH') {
      setInputToken('Token');
      setInputBalance(tokenBalance);
      setAmount(tokenOutAmount);
    } else {
      setInputToken('ETH');
      setInputBalance(accountBalance);
      setAmount(tokenOutAmount);
    }
  };
  useEffect(() => {
    const FetchAmount = async () => {
      try {
        let amounts;
        amounts = await readContract(config, {
          address: tokenAddress,
          abi: TokenAbi,
          functionName: 'balanceOf',
          args: [address],

        });
        let allowance;
        let approveAddress;
        approveAddress = FunAddress;
        allowance = await readContract(config, {
          address: tokenAddress,
          abi: TokenAbi,
          functionName: 'allowance',
          args: [address, approveAddress],

        });
        setTokenAllowance(Number(allowance) / 10 ** 18);
        setTokenBalance((Math.floor(web3Clients[chainId].utils.fromWei(String(amounts), 'ether'))));
      } catch (e) {
        console.error(e);
      }
    };
    if (address && tokenAddress) {
      FetchAmount();
    }
  }, [tokenAddress, address, creating, FunAddress, chainId]);

  useEffect(() => {
    const FetchTransaction = async () => {
      try {
        let transaction;
        let transactionData = [];
        for (let i = 0; i < transactions?.length; i++) {
          if (
            transactions[i].functionName.includes('buyToken') ||
            transactions[i].functionName.includes('sellToken')
          ) {
            let maker = transactions[i].from;
            let type;
            let amount;
            if (transactions[i].functionName.includes('buyToken')) {
              type = 'Buy';
            } else {
              type = 'Sell';
            }
            amount = tokenPriceDatas[i + 1].amount;
            amount = '$' + (Number(web3Clients[chainId].utils.fromWei(String(amount), 'ether')) * ethPrice).toLocaleString();
            let date = new Date(Number(transactions[i].timeStamp) * 1000).getTime() / 1000;
            let currentDate = Date.now();
            date = currentDate / 1000 - date;
            if (date > 86400) {
              date = (date / 86400).toFixed(0) + ' days ago';
            } else if (date > 3600) {
              date = (date / 3600).toFixed(0) + ' hours ago';
            } else if (date > 0) {
              date = (date / 60).toFixed(0) + ' mins ago';
            } else {
              date = ' just now';
            }
            if (date < 0) {
              date = 'just now';
            }
            let tx = transactions[i].hash;
            transaction = {
              Maker: maker,
              Type: type,
              Amount: amount,
              Date: date,
              Tx: tx
            };
            transactionData.push(transaction);
          }
        }
        setTransactionDatas(transactionData.reverse());
      } catch (e) {
        console.error(e);
      }
    };
    if (tokenAddress) {
      if (transactions?.length > 0) {
        FetchTransaction()
      }
      if (transactions?.length === 0) {
        getApi()
      }
    }
  }, [tokenAddress, transactions, chainId, ethPrice, tokenPriceDatas]);

  const [selectedOption, setSelectedOption] = useState('Chat');
  // Pagination State and Logic for Transactions Table
  const [currentTransactionPage, setCurrentTransactionPage] = useState(1);
  const [transactionTotalPages, setTransactionTotalPages] = useState(0);
  const transactionItemsPerPage = 5;
  const [transactionPageNumbers, setTransactionPageNumbers] = useState([]);
  const calculateTransactionPageNumbers = (totalPages, currentPage) => {
    let pages = [];

    if (totalPages <= 4) {
      pages = Array.from({ length: totalPages }, (_, i) => i + 1);
    } else {
      if (currentPage === 1) {
        pages = [1, 2, '...', totalPages - 1, totalPages];
      } else if (currentPage === totalPages) {
        pages = [1, 2, '...', totalPages - 1, totalPages];
      } else {
        if (currentPage + 1 < totalPages) {
          if (currentPage + 1 === totalPages - 1) {
            pages = [currentPage - 1, currentPage, currentPage + 1, totalPages];
          } else {
            pages = [
              currentPage - 1,
              currentPage,
              currentPage + 1,
              '...',
              totalPages
            ];
          }
        } else if (currentPage < totalPages) {
          pages = [currentPage - 1, currentPage, currentPage + 1];
        } else {
          pages = [1, 2, '...', totalPages - 1, totalPages];
        }
      }
    }

    return pages;
  };

  const handleTransactionPageChange = newPageNumber => {
    setCurrentTransactionPage(newPageNumber);
    setTransactionPageNumbers(
      calculateTransactionPageNumbers(transactionTotalPages, newPageNumber)
    );
  };

  useEffect(() => {
    const totalPages = Math.ceil(
      transactionDatas.length / transactionItemsPerPage
    );
    setTransactionTotalPages(totalPages);
    setTransactionPageNumbers(
      calculateTransactionPageNumbers(totalPages, currentTransactionPage)
    );
  }, [transactionDatas, currentTransactionPage]);

  const useScript = url => {
    useEffect(() => {
      const script = document.createElement('script');

      script.src = url;
      script.async = true;

      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }, [url]);
  };

  function isMobile() {
    try {
      document.createEvent('TouchEvent');
      return true;
    } catch (e) {
      return false;
    }
  }

  return (
    <div style={{ background: 'var(--page-bg)' }}>
      {useScript('../../charting_library/charting_library.js')}
      <TopBar />
      <div className="max-w-7xl mx-auto pt-28 pb-16 px-4 sm:px-6">
        <div className='flex flex-col lg:flex-row gap-6'>
          {/* Left Column */}
          <div className="lg:w-2/3">
            {/* Chart Section */}
            <div className="rounded-xl overflow-hidden mb-6" style={{
              background: 'var(--card-bg)',
              border: '1px solid transparent',
              backgroundImage: 'linear-gradient(var(--card-bg), var(--card-bg)), var(--card-border)',
              backgroundOrigin: 'border-box',
              backgroundClip: 'padding-box, border-box',
              boxShadow: 'var(--shadow)'
            }}>
              {lpCreated ? (
                <iframe
                  src={`https://dexscreener.com/${chainNames[chainId]}/${tokenAddress}?embed=1&trades=0&info=0&theme=${theme}`}
                  className="w-full h-[500px]"
                  title="chart"
                />
              ) : isMobile() ? (
                <MyChart data={tokenPriceDatas} ethPrice={ethPrice} />
              ) : (
                <Chart data={tokenPriceDatas} ethPrice={ethPrice} interval="30" symbol={tokenSymbol} />
              )}
            </div>

            {/* Chat/Trades Section */}
            <div className="rounded-xl p-6" style={{
              background: 'var(--header-bg)',
              border: '1px solid transparent',
              backgroundOrigin: 'border-box',
              backgroundClip: 'padding-box, border-box',
              boxShadow: 'var(--shadow)'
            }}>
              <div className="flex gap-4 mb-6">
                <CustomRadioButton
                  value="Chat"
                  selectedValue={selectedOption}
                  handleSelect={setSelectedOption}
                />
                <CustomRadioButton
                  value="Trades"
                  selectedValue={selectedOption}
                  handleSelect={setSelectedOption}
                />
              </div>

              {/* Trades Section */}
              {selectedOption === 'Trades' && (
                <div>
                  <div className="grid grid-cols-5 gap-4 p-3 mb-4 text-sm" style={{
                    background: 'var(--section-bg)',
                    borderRadius: '8px'
                  }}>
                    <div className="font-medium" style={{ color: 'var(--text-primary)' }}>Maker</div>
                    <div className="font-medium" style={{ color: 'var(--text-primary)' }}>Type</div>
                    <div className="font-medium" style={{ color: 'var(--text-primary)' }}>Amount</div>
                    <div className="font-medium" style={{ color: 'var(--text-primary)' }}>Date</div>
                    <div className="font-medium" style={{ color: 'var(--text-primary)' }}>Tx</div>
                  </div>

                  {transactionDatas.length === 0 ? (
                    <div className="text-center py-6" style={{ color: 'var(--text-primary)' }}>No Data</div>
                  ) : (
                    <>
                      <div className="space-y-2 mb-6">
                        {transactionDatas
                          .slice(
                            (currentTransactionPage - 1) * transactionItemsPerPage,
                            currentTransactionPage * transactionItemsPerPage
                          )
                          .map(({ Maker, Type, Amount, Date, Tx }) => (
                            <div key={Tx} className="grid grid-cols-5 gap-4 p-3 text-sm" style={{
                              background: 'var(--section-bg)',
                              borderRadius: '8px'
                            }}>
                              <a
                                href={scanLinks[chainId] + 'address/' + Maker}
                                target="_blank"
                                rel="noreferrer"
                                className="flex items-center text-blue-500 "
                              >
                                {Maker.slice(0, 5) + '...' + Maker.slice(-3)}
                              </a>
                              <div style={{ color: Type === 'Buy' ? '#10B981' : '#EF4444' }}>
                                {Type}
                              </div>
                              <div style={{ color: 'var(--text-primary)' }}>{Amount}</div>
                              <div style={{ color: 'var(--text-primary)' }}>{Date}</div>
                              <a
                                href={scanLinks[chainId] + 'tx/' + Tx}
                                target="_blank"
                                rel="noreferrer"
                                className="flex items-center text-blue-500 "
                              >
                                {Tx.slice(0, 5) + '...' + Tx.slice(-3)}
                              </a>
                            </div>
                          ))}
                      </div>

                      {/* Pagination */}
                      <div className="flex justify-center gap-2">
                        <button
                          className="px-3 py-1 rounded"
                          onClick={() => handleTransactionPageChange(1)}
                          style={{
                            background: 'var(--button-secondary-bg)',
                            border: '1px solid var(--button-secondary-border)',
                            color: 'var(--button-secondary-text)'
                          }}
                        >
                          &lt;&lt;
                        </button>
                        <button
                          className="px-3 py-1 rounded"
                          onClick={() => handleTransactionPageChange(Math.max(currentTransactionPage - 1, 1))}
                          style={{
                            background: 'var(--button-secondary-bg)',
                            border: '1px solid var(--button-secondary-border)',
                            color: 'var(--button-secondary-text)'
                          }}
                        >
                          &lt;
                        </button>
                        {transactionPageNumbers.map((pageNumber, index) => (
                          <button
                            key={index}
                            className={`px-3 py-1 rounded ${currentTransactionPage === pageNumber
                              ? 'bg-gradient-to-r from-blue-500 to-cyan-500 text-white'
                              : 'bg-transparent'}`}
                            onClick={() => typeof pageNumber === 'number' && handleTransactionPageChange(pageNumber)}
                            style={{
                              border: '1px solid var(--input-border)',
                              color: typeof pageNumber === 'number'
                                ? currentTransactionPage === pageNumber
                                  ? 'white'
                                  : 'var(--text-primary)'
                                : 'var(--text-primary)',
                              background: typeof pageNumber === 'number' && currentTransactionPage === pageNumber
                                ? 'var(--button-bg)'
                                : 'var(--card-bg)'
                            }}
                          >
                            {pageNumber}
                          </button>
                        ))}
                        <button
                          className="px-3 py-1 rounded"
                          onClick={() => handleTransactionPageChange(Math.min(currentTransactionPage + 1, transactionTotalPages))}
                          style={{
                            background: 'var(--button-secondary-bg)',
                            border: '1px solid var(--button-secondary-border)',
                            color: 'var(--button-secondary-text)'
                          }}
                        >
                          &gt;
                        </button>
                        <button
                          className="px-3 py-1 rounded"
                          onClick={() => handleTransactionPageChange(transactionTotalPages)}
                          style={{
                            background: 'var(--button-secondary-bg)',
                            border: '1px solid var(--button-secondary-border)',
                            color: 'var(--button-secondary-text)'
                          }}
                        >
                          &gt;&gt;
                        </button>
                      </div>
                    </>
                  )}
                </div>
              )}

              {/* Chat Section */}
              {selectedOption === 'Chat' && (
                <div className="p-4 rounded-md" style={{
                  background: 'var(--section-bg)',
                  border: '1px solid var(--border-color)'
                }}>
                  {chatHistory.length > 0 ? (
                    <div className="space-y-4">
                      {chatHistory.map(({ Sender, Content, Date, avatar }) => (
                        <div key={Sender + Date} className="p-4 rounded-lg" style={{
                          background: 'var(--card-bg)',
                          border: '1px solid var(--border-color)'
                        }}>
                          <div className="flex items-start gap-3">
                            <Jazzicon diameter={40} seed={jsNumberForAddress(Sender)} />
                            <div>
                              <div className="flex items-center gap-2">
                                <Link
                                  to={'/profile/?address=' + Sender}
                                  className="font-medium hover:underline"
                                  style={{ color: 'var(--text-primary)' }}
                                >
                                  {Sender.slice(0, 5) + '...' + Sender.slice(-3)}
                                </Link>
                                <span className="text-xs" style={{ color: 'var(--text-primary)' }}>{Date}</span>
                              </div>
                              <p className="mt-2" style={{ color: 'var(--text-primary)' }}>{Content}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-center py-6" style={{ color: 'var(--text-primary)' }}>No chat history</div>
                  )}
                  <div className="mt-6">
                    <SignMessage
                      FunAddress={FunAddress}
                      sender={address}
                      content={chatContent}
                      timestamp={(Date.now() / 1000).toFixed(0)}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Right Column */}
          <div className="lg:w-1/3 space-y-6">
            {/* PancakeSwap Banner */}
            {lpCreated && (
              <a
                href={`https://pancakeswap.finance/swap?chain=${chainNames[chainId]}&inputCurrency=BNB&outputCurrency=${tokenAddress}`}
                target='_blank' rel="noreferrer"
              >
                <div className='rounded-xl overflow-hidden'>
                  <img src={pancakeBannerImg} className="w-full h-auto" />
                </div>
              </a>
            )}

            {/* Swap Card */}
            {!lpCreated && (
              <div className="rounded-xl p-6" style={{
                background: 'var(--card-bg)',
                border: '1px solid transparent',
                backgroundImage: 'linear-gradient(var(--card-bg), var(--card-bg)), var(--card-border)',
                backgroundOrigin: 'border-box',
                backgroundClip: 'padding-box, border-box',
                boxShadow: 'var(--shadow)'
              }}>
                <div className="flex justify-between items-center mb-4">
                  <h3 className="text-xl font-bold" style={{ color: 'var(--text-primary)' }}>{tokenSymbol}</h3>
                  {address && (
                    <button onClick={copyAddress(tokenAddress)} className="flex items-center gap-1 text-blue-500">
                      <span className="truncate max-w-[120px]">{tokenAddress.slice(0, 6)}...{tokenAddress.slice(-4)}</span>
                      <img src={CopyIcon} alt="Copy" className="w-4 h-4" />
                    </button>
                  )}
                </div>

                <div className="space-y-4">
                  {/* From Card */}
                  <div className="p-4 rounded-lg" style={{
                    background: 'var(--section-bg)',
                    border: '1px solid var(--border-color)'
                  }}>
                    <div className="flex justify-between items-center">
                      <div className="flex items-center gap-3">
                        <img
                          src={inputToken === 'ETH' ? ethIcon[chainId] : tokenLogo}
                          alt="From token"
                          className="w-10 h-10 rounded-full"
                          onError={e => {
                            e.target.onerror = null;
                            e.target.src = '/logo.png';
                          }}
                        />
                        <div>
                          <p className="text-sm" style={{ color: 'var(--text-primary)' }}>From</p>
                          <p className="font-bold" style={{ color: 'var(--text-primary)' }}>
                            {inputToken === 'ETH' ? coinNames[chainId] : tokenSymbol}
                          </p>
                        </div>
                      </div>
                      <div className="text-right">
                        <input
                          type="number"
                          placeholder="0"
                          value={tokenAmount}
                          onChange={e => setAmount(e.target.value)}
                          className="w-full text-right bg-transparent focus:outline-none text-lg font-bold"
                          style={{ color: 'var(--text-primary)' }}
                        />
                        <p className="text-sm mt-1" style={{ color: 'var(--text-primary)' }}>
                          Balance: {Number(inputToken === 'ETH' ? accountBalance : tokenBalance).toLocaleString()}
                          <button
                            onClick={setMaxAmount}
                            className="ml-2 px-2 py-1 rounded-full text-xs font-medium transition-all"
                            style={{
                              backgroundColor: 'var(--button-bg)',
                              color: 'var(--button-text)',
                              minWidth: '32px'
                            }}
                          >
                            Max
                          </button>
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Swap Icon */}
                  <div className="flex justify-center">
                    <button onClick={chanageCurrency}>
                      <img src={theme === 'dark' ? swapIconDark : swapIconLight} alt="Swap" className="w-6 h-6" style={{ filter: 'var(--icon-filter)' }} />
                    </button>
                  </div>

                  {/* To Card */}
                  <div className="p-4 rounded-lg" style={{
                    background: 'var(--section-bg)',
                    border: '1px solid var(--border-color)'
                  }}>
                    <div className="flex justify-between items-center">
                      <div className="flex items-center gap-3">
                        <img
                          src={inputToken !== 'ETH' ? ethIcon[chainId] : tokenLogo}
                          alt="To token"
                          className="w-10 h-10 rounded-full"
                          onError={e => {
                            e.target.onerror = null;
                            e.target.src = '/logo.png';
                          }}
                        />
                        <div>
                          <p className="text-sm" style={{ color: 'var(--text-primary)' }}>To</p>
                          <p className="font-bold" style={{ color: 'var(--text-primary)' }}>
                            {inputToken !== 'ETH' ? coinNames[chainId] : tokenSymbol}
                          </p>
                        </div>
                      </div>
                      <div className="text-right">
                        <input
                          placeholder="0"
                          value={(tokenOutAmount)}
                          disabled
                          className="w-full text-right bg-transparent text-lg font-bold"
                          style={{ color: 'var(--text-primary)' }}
                        />
                        <p className="text-sm mt-1" style={{ color: 'var(--text-primary)' }}>
                          Balance: {Number(inputToken !== 'ETH' ? accountBalance : tokenBalance).toLocaleString()}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Swap Button */}
                  <button
                    onClick={onTokenSwap}
                    className="w-full py-3 rounded-lg font-bold transition-all"
                    disabled={!address || (Number(tokenAmount) <= 0 ||
                      (inputToken === 'ETH' ? accountBalance < Number(tokenAmount) : tokenBalance < Number(tokenAmount)))}
                    style={{
                      background: 'var(--button-bg)',
                      color: 'var(--button-text)',
                      opacity: !address || (Number(tokenAmount) <= 0 ||
                        (inputToken === 'ETH' ? accountBalance < Number(tokenAmount) : tokenBalance < Number(tokenAmount))) ? 0.5 : 1
                    }}
                  >
                    {creating ? (
                      <ClipLoader color="var(--button-text)" size={24} />
                    ) : inputToken !== 'ETH' && tokenAllowance === 0 ? (
                      'Approve token First'
                    ) : (
                      'Swap Tokens'
                    )}
                  </button>
                </div>
              </div>
            )}

            {/* Claim Card */}
            <ClaimCard
              tokenName={tokenName}
              banner={<img src={tokenBanner} className="claim-eth-banner w-[30%]" onError={e => {e.target.onerror = null; e.target.src = '/logo.png';}}/>}
              maxLimit={maxLimit}
              tokenSymbol={tokenSymbol}
              tokenSupplyUSD={2 * virtualLp * ethPrice}
              volume={volume}
              website={website}
              telegram={telegram}
              twitter={twitter}
              description={description}
              ethPrice={ethPrice}
              lpCreated={lpCreated}
              tokenPrice={tokenPrice}
            />

            {/* Referral Card */}
            <div className="rounded-xl p-6" style={{
              background: 'var(--card-bg)',
              border: '1px solid transparent',
              backgroundImage: 'linear-gradient(var(--card-bg), var(--card-bg)), var(--card-border)',
              backgroundOrigin: 'border-box',
              backgroundClip: 'padding-box, border-box',
              boxShadow: 'var(--shadow)'
            }}>
              <h3 className="text-xl font-bold mb-4 text-center" style={{ color: 'var(--text-primary)' }}>
                Earn <span style={{ color: 'var(--text-accent)' }}>0.5%</span> of each trade
              </h3>
              <p className="text-center mb-4" style={{ color: 'var(--text-primary)' }}>
                Share referral link with your friends and earn 0.5% of every trade they make.
              </p>

              <div className="flex gap-2 mb-6">
                <div className="flex-1 p-3 rounded-lg truncate" style={{
                  border: '1px solid var(--input-border)',
                  color: 'var(--text-primary)'
                }}>
                  {referlink}
                </div>
                <button
                  className="p-3 rounded-lg flex items-center justify-center"
                  onClick={copyAddress(referlink)}
                  style={{
                    background: 'var(--button-secondary-bg)',
                    border: '2px solid var(--button-secondary-border)',
                    color: 'var(--button-secondary-text)',
                    minWidth: '44px'
                  }}
                >
                  <ClipboardIcon />
                </button>
              </div>

              {/* Referral stats */}
              {refUserAmount > 0 && (
                <div className="space-y-3">
                  <div className="flex justify-between">
                    <span style={{ color: 'var(--text-primary)' }}>Total Referral Amounts:</span>
                    <span style={{ color: 'var(--text-primary)' }}>{totalRefAmounts.toFixed(8)} ETH</span>
                  </div>
                  <div className="flex justify-between">
                    <span style={{ color: 'var(--text-primary)' }}>Total Ref Counts:</span>
                    <span style={{ color: 'var(--text-primary)' }}>{refCounts}</span>
                  </div>
                  <div className="flex justify-between">
                    <span style={{ color: 'var(--text-primary)' }}>Your referral amounts:</span>
                    <span style={{ color: 'var(--text-primary)' }}>{refUserAmount.toFixed(8)} ETH</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default App;

const ClipboardIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    width="20"
    height="20"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V7a2 2 0 00-2-2h-2m-2-2h-4m0 0h4m-4 0v2h4V3m-4 6h4"
    />
  </svg>
);
